// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-other[data-v-438ae0f0] .el-checkbox__label {\n  padding-left: 4px;\n}\n.form-other[data-v-438ae0f0] .el-form-item__content,\n.form-other[data-v-438ae0f0] .el-checkbox {\n  line-height: 28px;\n  display: block;\n}\n.form-other .name-text[data-v-438ae0f0] {\n  font-size: 14px;\n  color: #2F3030;\n}\n.form-other .min-text[data-v-438ae0f0] {\n  font-size: 12px;\n  color: #C5C9C9;\n  display: inline-block;\n  padding-left: 8px;\n}", ""]);
// Exports
module.exports = exports;
